import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import './style.scss';

const EmptyComparisonMessageComponent = ({ offGraphSignalsCount }) => {
    const { t: translate } = useTranslation();
    const hasOffGraphSignals = offGraphSignalsCount > 0;

    return (
        <div className='cross-asset-empty-comparison-message'>
            <h3>{translate('ABB.Powertrain.Frontend.chartNoKPIsSelected')}</h3>
            {hasOffGraphSignals &&
                <>
                    <p>
                        {translate('ABB.Powertrain.Frontend.crossAssetGraphEmptyOffGraphOnly', { count: offGraphSignalsCount })}
                    </p>
                    <p>
                        {translate('ABB.Powertrain.Frontend.crossAssetGraphEmptyOffGraphInstruction')}
                    </p>
                    <div className='cross-asset-empty-comparison-message-divider'>
                        {translate('ABB.Powertrain.Frontend.crossAssetGraphEmptyOrDivider')}
                    </div>
                </>
            }
            <ol>
                <li>{translate('ABB.Powertrain.Frontend.crossAssetGraphEmptyStep1')}</li>
                <li>{translate('ABB.Powertrain.Frontend.crossAssetGraphEmptyStep2')}</li>
            </ol>
            <p>
                {translate('ABB.Powertrain.Frontend.crossAssetGraphEmptyFooter')}
            </p>
        </div>
    );
};

export default EmptyComparisonMessageComponent;

EmptyComparisonMessageComponent.propTypes = {
    offGraphSignalsCount: PropTypes.number
};

EmptyComparisonMessageComponent.defaultProps = {
    offGraphSignalsCount: 0
};
